import Config from '../config';

export const CONTENT_PROVIDER_AUTH = {
  IDP: Config.cloudpass.IDP_SHORTCODE,
};
